import { render, staticRenderFns } from "./ChecklistStringFieldModule.vue?vue&type=template&id=5263bd0a&scoped=true"
import script from "./ChecklistStringFieldModule.vue?vue&type=script&lang=ts"
export * from "./ChecklistStringFieldModule.vue?vue&type=script&lang=ts"
import style0 from "./ChecklistStringFieldModule.vue?vue&type=style&index=0&id=5263bd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5263bd0a",
  null
  
)

export default component.exports